import {EventEmitter, Injectable, OnDestroy} from '@angular/core';
import {BingMapMarker} from "../bing-map-marker";
import {BehaviorSubject} from 'rxjs';
import {AbstractMapService} from "./abstract-map.service";
import {TranslateService} from "../../shared/translate.service";

@Injectable({
  providedIn: 'root'
})
export class UserPositionService implements OnDestroy {

  private watchId;

  public lastPosition: BingMapMarker = undefined;
  public position: Position = undefined;

  positionEmitter: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private translateService: TranslateService) {
  }

  ngOnDestroy(): void {
    navigator.geolocation.clearWatch(this.getWatchId());
  }

  getWatchId() {
    return this.watchId;
  };

  setWatchId(watchId) {
    this.watchId = watchId;
  };

  public emitCurrentLocalization(): void {
    if (this.watchId !== undefined) {
      if (this.position) {
        this.positionEmitter.next(new BingMapMarker(this.position.coords.latitude, this.position.coords.longitude));
      }
      else {
        this.positionEmitter.next(this.lastPosition);
      }
    }
    else {
      this.setWatchId(navigator.geolocation.watchPosition(position => {
          this.position = position;
          this.positionEmitter.next(new BingMapMarker(this.position.coords.latitude, this.position.coords.longitude));
        }, error => {
          console.error(error);
          this.position = undefined;
          this.positionEmitter.next(undefined);
        }, {maximumAge: 0}
      ));
    }
  }

  public createDistanceLabel(location: BingMapMarker, accessDenied: boolean): string {
    if (this.position) {
      return Math.floor(UserPositionService.calculateDistance(
        new BingMapMarker(this.position.coords.latitude, this.position.coords.longitude), location)) +
        `${this.translateService.translate('bing-maps.distance')}`;
    } else {
      return ``;
    }
  }

  /**
   * Returns distance between two points (kilometers)
   * @param {BingMapMarker} p1 first point
   * @param {BingMapMarker} p2 second point
   * @returns {number} distance (KM) - straight line
   */
  static calculateDistance(p1: BingMapMarker, p2: BingMapMarker): number {
    let p = 0.017453292519943295;    // Math.PI / 180
    let c = Math.cos;
    let a = 0.5 - c((p1.lat - p2.lat) * p) / 2 + c(p2.lat * p) * c((p1.lat) * p) * (1 - c(((p1.lon - p2.lon) * p))) / 2;
    return (12742 * Math.asin(Math.sqrt(a)));
  }
}
